import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spinner, Card } from "react-bootstrap";
import ApiPageContent from "../../../core/api/api.pageContent";
import ApiHome from "../../../core/api/api.home";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import TextEditor from "../_Components/CkEditor/Index";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiRegion from "../../../core/api/api.region";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AddFaqModal from "./AddFaqModal";
import AddPhoneModal from "./AddPhoneModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SwalMessage from "../_Components/SwalMessage";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import _ from "lodash";
import Swal from "sweetalert2";
import SelectComponent from "../_Components/ReactSelectComponent";

function SinglePageContent() {
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [type, setType] = useState();

  const [QA, setQA] = useState([]);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState([]);
  const [selectedFaqId, setSelectedFaqId] = useState([]);

  const [phone, setPhone] = useState({
    phones: [],
    showPhoneModal: false,
    selectedPhone: null,
    selectedPhoneId: null,
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    defaultValues: {
      id,
    },
  });

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست شهر ها و دسته بندی ها
        const allCities = await ApiRegion.getAllCity();
        const allCategories = await ApiAmusementGroup.getAllGroups();
        const types = await ApiHome.getEnums({ enumName: "PageType" });
        setTypes(types.data);
        setCities(allCities);
        setCategories(allCategories);
        if (+id !== 0) {
          // this is for update
          const response = await ApiPageContent.getPageContentById({ id });
          if (!_.isEmpty(response?.data)) {
            setValue("type", types.data?.map((item) => ({
              value: item.id,
              label: item.title,
            })).find(item => item.value == response?.data?.type));
            setValue("status", response?.data?.status || false);
            setValue("isNoIndex", response?.data?.isNoIndex || false);
            setType(response?.data?.type);
            if (response?.data?.type === 3 || response?.data?.type === 1) {
              let contactInfoContent = {};
              try {
                contactInfoContent = JSON.parse(response?.data?.content || "{}");
                setValue("headerContent", contactInfoContent.HeaderContent);
                setValue("content", contactInfoContent.PageContent);
              } catch (error) {
                setValue("headerContent", response?.data?.content);
              } finally {
              }

              if (response?.data?.type === 3) {
                setValue("address", contactInfoContent.Address);
                const phones = contactInfoContent.Phones?.map((item, index) => {
                  return {
                    title: item.Title,
                    phone: item.Phone,
                  };
                });
                setPhone((prev) => ({
                  ...prev,
                  phones: phones,
                }));
                setValue("phones", [...phones]);
              }
            } else {
              setValue("content", response?.data?.content);
            }
            // تنظیم کردن شهر
            const regionId = allCities.find((item) => item.id === response?.data?.regionId);
            setValue("regionId", { value: regionId?.id || undefined, label: regionId?.name || undefined });
            // تنظیم کردن دسته بندی
            const amusementGroupId = allCategories.find((item) => item.id === response?.data?.amusementGroupId);
            setValue("amusementGroupId", {
              value: amusementGroupId?.id || undefined,
              label: amusementGroupId?.title || undefined,
            });
            setValue("h1", response?.data?.h1);
            setValue("pageTitle", response?.data?.pageTitle);
            setValue("metaDescription", response?.data?.metaDescription);
            const faqJson = JSON.parse(response?.data?.faqJson || "[]");
            setValue("questionAnswers", faqJson);
            setQA(faqJson);
          }
        } else {
          // this part is for create
          setValue("type", types.data?.map((item) => ({
            value: item.id,
            label: item.title,
          }))[0]);
          setValue("status", true);
          setType(1);
        }
      } catch (error) {
        console.log(error)
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    data.amusementGroupId = data.amusementGroupId?.value;
    data.type = data.type?.value
    data.regionId = data.regionId?.value;

    data.contactInfoContent = {
      ...((type === 1 || type === 3) && {
        pageContent: data.content,
        headerContent: data.headerContent,
      }),
      ...(type === 3 && {
        address: data.address,
        phones: data.phones,
      }),
    };

    try {
      const response =
        id == 0 ? await ApiPageContent.createPageContent(data) : await ApiPageContent.updatePageContent(data);
      if (response.succeeded == true) navigate("/pageContent");

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const handleDeleteFaq = (index) => {
    Swal.fire({
      title: "عملیات حذف پرسش و پاسخ",
      text: "ایا قصد حذف این پرسش و پاسخ را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        const filteredQA = QA.filter((item, i) => i !== index);
        setQA(filteredQA);
        setValue("questionAnswers", [...filteredQA]);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  };

  const handleDeletePhone = (index) => {
    Swal.fire({
      title: "عملیات حذف تلفن",
      text: "ایا قصد حذف این تلفن را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        const filteredPhones = phone.phones.filter((item, i) => i !== index);
        setPhone((prev) => ({
          ...prev,
          phones: filteredPhones,
        }));
        setValue("phones", [...filteredPhones]);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  };

  return (
    <div className={`card card-custom`}>
      <div className="card-header border-0 pt-5 d-flex justify-content-between align-items-center">
        <h3 className="card-title align-items-start flex-column mb-0">
          <span className="card-label font-weight-bolder text-dark">
            {id !== "0" ? "ویرایش محتوای صفحات" : "ایجاد محتوای جدید"}
          </span>
        </h3>
        <div className="card-toolbar d-flex justify-content-end"></div>
      </div>
      <div className="card-body pt-3">
        <div className="border-top pt-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col sm="6" xl="3">
                <Controller
                  name="type"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <SelectComponent
                      className="mt-5 w-100"
                      placeholder="نوع صفحه"
                      variant="outlined"
                      margin="normal"
                      size="small"
                      options={types?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      value={value}
                      onChange={(e) => {
                        onChange(e);
                        setType(e.value);
                      }}
                      noClear
                    />
                  )}
                />
                {errors.type && <span>لطفا نوع صفحه را وارد نمایید</span>}
              </Col>
              {type == 1 && (
                <>
                  <Col sm="6" xl="3" className="">
                    <Controller
                      name="regionId"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-5 w-100"
                          placeholder="شهر"
                          options={cities.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                          field={field}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="">
                    <Controller
                      name="amusementGroupId"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-5 w-100"
                          placeholder="دسته "
                          options={categories.map((item) => ({
                            value: item.id,
                            label: item.title,
                          }))}
                          field={field}
                        />
                      )}
                    />
                  </Col>
                </>
              )}
              {type !== undefined && (type == 1 || type == 2 || type == 4) && (
                <Col sm="6" xl="3" className="">
                  <Controller
                    name="h1"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="h1"
                        className="mt-5"
                        variant="outlined"
                        margin="normal"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
              )}
              {(type == 1 || type == 4) && (
                <>
                  <Col sm="6" xl="6" className="">
                    <Controller
                      name="pageTitle"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="عنوان صفحه"
                          className="mt-5"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="6" className="">
                    <Controller
                      name="metaDescription"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="metaDescription"
                          className="mt-5"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                </>
              )}
              {(type == 1 || type == 3) && (
                <>
                  <Col xs="12" className="mt-5">
                    <h6 className="mb-4">توضیحات هدر</h6>
                    <Controller
                      name="headerContent"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextEditor
                          data={value || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            onChange(data);
                          }}
                        />
                      )}
                    />
                  </Col>
                </>
              )}

              <Col xs="12" className="mt-5">
                <h6 className="mb-4">توضیحات</h6>
                <Controller
                  name="content"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextEditor
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12" className="mt-5">
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"status"}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Checkbox
                          color="primary"
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value || false}
                          inputRef={ref}
                        />
                      )}
                    />
                  }
                  label="فعال"
                />
              </Col>
              <Col xs="12" className="mt-5">
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"isNoIndex"}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Checkbox
                          color="primary"
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value || false}
                          inputRef={ref}
                        />
                      )}
                    />
                  }
                  label="توسط گوگل ایندکس نشود"
                />
              </Col>
              {type == 1 && (
                <>
                  <div className="mt-5 pl-4">
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowFaqModal(true);
                        setSelectedFaq({});
                      }}
                    >
                      <AddCircle className="mr-1" />
                      افزودن پرسش و پاسخ
                    </Button>
                    {/* <Button className="mt-0 ml-3" variant="success" type="submit" disabled={isSubmitting}>
                      {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                      <SaveIcon /> ذخیره
                    </Button>
                    <Button
                      className="mt-0 ml-3"
                      variant="danger"
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => navigate("/pageContent")}
                    >
                      <CloseIcon />
                      بازگشت
                    </Button> */}
                  </div>

                  {QA?.length > 0 ? (
                    <Row>
                      {QA?.map((item, index) => (
                        <Col key={index} xs="12" sm="6" lg="4" className="mt-5">
                          <Card className="h-100" style={{ borderColor: "#ccc" }}>
                            <Card.Body className="p-3">
                              <div className="border-bottom border-secondary mb-3">
                                <p className="fw-bold pl-1">پرسش:</p>
                                <p dangerouslySetInnerHTML={{ __html: item.QuestionText }}></p>
                              </div>
                              <div className="mt-2">
                                <p className="fw-bold">پاسخ:</p>
                                <p className="mt-3" dangerouslySetInnerHTML={{ __html: item.AnswerText }}></p>
                              </div>
                            </Card.Body>
                            <Card.Footer className="p-3">
                              <Button
                                className="btn btn-light-primary btn-sm mr-2 btn-icon"
                                onClick={() => {
                                  setShowFaqModal(true);
                                  setSelectedFaq(item);
                                  setSelectedFaqId(index);
                                }}
                              >
                                <i className="far fa-edit text-small"></i>
                              </Button>
                              <Button
                                className="btn btn-light-danger btn-sm btn-icon"
                                onClick={() => {
                                  handleDeleteFaq(index);
                                }}
                              >
                                <i className="far fa-trash-alt text-small"></i>
                              </Button>
                            </Card.Footer>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <div className="my-3 pl-6">پرسش و پاسخی ثبت نشده است.</div>
                  )}
                </>
              )}

              {type == 3 && (
                <>
                  <Col xs="12" className="">
                    <Controller
                      name="address"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="آدرس"
                          className="mt-5"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>

                  <div className="mt-5 pl-4">
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        setPhone((prev) => ({ ...prev, showPhoneModal: true, selectedPhone: {} }));
                      }}
                    >
                      <AddCircle className="mr-1" />
                      افزودن شماره تلفن
                    </Button>
                    {/* <Button className="mt-0 ml-3" variant="success" type="submit" disabled={isSubmitting}>
                      {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                      <SaveIcon /> ذخیره
                    </Button>
                    <Button
                      className="mt-0 ml-3"
                      variant="danger"
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => navigate("/pageContent")}
                    >
                      <CloseIcon />
                      بازگشت
                    </Button> */}
                  </div>

                  {phone?.phones?.length > 0 ? (
                    <Row className="mt-4">
                      {phone?.phones?.map((item, index) => (
                        <Col key={index} xs="12" sm="6" md="4" xl="3">
                          <div className="rounded my-3 p-3" style={{ border: "1px solid #ccc" }}>
                            <div className="border-bottom border-secondary mb-3">
                              <p className="fw-bold">عنوان:</p>
                              <p className="mt-3" dangerouslySetInnerHTML={{ __html: item.title }}></p>
                            </div>
                            <div className="mt-2">
                              <p className="fw-bold">تلفن:</p>
                              <p className="mt-3" dangerouslySetInnerHTML={{ __html: item.phone }}></p>
                            </div>
                            <Button
                              className="btn btn-light-primary btn-sm mr-2 btn-icon"
                              onClick={() => {
                                setPhone((prev) => ({
                                  ...prev,
                                  showPhoneModal: true,
                                  selectedPhone: item,
                                  selectedPhoneId: index,
                                }));
                              }}
                            >
                              <i className="far fa-edit text-small"></i>
                            </Button>
                            <Button
                              className="btn btn-light-danger btn-sm btn-icon"
                              onClick={() => {
                                handleDeletePhone(index);
                              }}
                            >
                              <i className="far fa-trash-alt text-small"></i>
                            </Button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <div className="my-3 pl-6">شماره تلفنی ثبت نشده است.</div>
                  )}
                </>
              )}
            </Row>

            <div className="mt-5 border-top pt-5 text-end">
              <Button className="mt-0 mr-3" variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button
                className="mt-0 mr-3"
                variant="danger"
                type="button"
                disabled={isSubmitting}
                onClick={() => navigate("/pageContent")}
              >
                <CloseIcon />
                بازگشت
              </Button>
            </div>
          </form>

          {showFaqModal && (
            <AddFaqModal
              showFaqModal={showFaqModal}
              setShowFaqModal={setShowFaqModal}
              setQA={setQA}
              selectedFaq={selectedFaq}
              setValue={setValue}
              selectedFaqId={selectedFaqId}
              QA={QA}
            />
          )}
          {phone.showPhoneModal && <AddPhoneModal setValue={setValue} phone={phone} setPhone={setPhone} />}
        </div>
      </div>
    </div>
  );
}

export default SinglePageContent;
